import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import * as actions from './purchase.actions';
import { PurchaseState, initialState } from './purchase.state';

const reducer: ActionReducer<PurchaseState, Action> = createReducer(
  initialState,

  on(
    actions.getAvailableProducts,
    (state): PurchaseState => ({
      ...state,
      loadingAvailableProducts: true,
      errorMessage: null,
      availableProducts: [],
    })
  ),
  on(
    actions.getAvailableProductsSuccess,
    (state, { products }): PurchaseState => ({
      ...state,
      loadingAvailableProducts: false,
      errorMessage: null,
      availableProducts: products,
    })
  ),
  on(
    actions.getAvailableProductsError,
    (state): PurchaseState => ({
      ...state,
      loadingAvailableProducts: false,
      errorMessage: 'ERROR_FETCHING_AVAILABLE_PRODUCTS',
    })
  ),

  on(
    actions.getAvailablePaymentMethods,
    (state): PurchaseState => ({
      ...state,
      loadingPaymentMethods: true,
      errorMessage: null,
    })
  ),
  on(
    actions.getAvailablePaymentMethodsSuccess,
    (state, { paymentMethods }): PurchaseState => ({
      ...state,
      loadingPaymentMethods: false,
      errorMessage: null,
      availablePaymentMethods: paymentMethods,
    })
  ),
  on(
    actions.getAvailablePaymentMethodsError,
    (state): PurchaseState => ({
      ...state,
      loadingPaymentMethods: false,
      availablePaymentMethods: null,
      errorMessage: 'ERROR_FETCHING_AVAILABLE_PAYMENT_METHODS_FROM_P24',
    })
  ),

  on(
    actions.getMyPurchase,
    (state, { purchaseId }): PurchaseState => ({
      ...state,
      loadingPurchase: true,
      // keep the same purchase while refreshing it - avoids UI flicker during polling
      myPurchase: state.myPurchase?.id === purchaseId ? state.myPurchase : null,
      errorMessage: null,
    })
  ),
  on(
    actions.validatePurchase,
    (state, {}): PurchaseState => ({
      ...state,
      loadingPurchase: true,
      // myPurchase: null,
      errorMessage: null,
    })
  ),
  on(
    actions.validatePurchaseSuccess,
    actions.newPurchaseSuccess,
    actions.getMyPurchaseSuccess,
    (state, { purchase }): PurchaseState => ({
      ...state,
      loadingPurchase: false,
      errorMessage: null,
      creatingPurchaseInProgress: false,
      myPurchase: structuredClone(purchase),
    })
  ),
  on(
    actions.getMyPurchaseError,
    (state, {}): PurchaseState => ({
      ...state,
      loadingPurchase: false,
      myPurchase: null,
      creatingPurchaseInProgress: false,
      errorMessage: 'GETTING_PURCHASE_ERROR',
    })
  ),
  on(
    actions.validatePurchaseError,
    (state, {}): PurchaseState => ({
      ...state,
      loadingPurchase: false,
      // myPurchase: null, -> at validation lets do nothing with purchase. User wont be able to proceed and we dont want to reset his cart completely
      creatingPurchaseInProgress: false,
      errorMessage: 'VALIDATING_PURCHASE_ERROR',
    })
  ),
  on(
    actions.newPurchase,
    (state): PurchaseState => ({
      ...state,
      creatingPurchaseInProgress: true,
    })
  ),
  on(
    actions.newPurchaseError,
    (state, {}): PurchaseState => ({
      ...state,
      loadingPurchase: false,
      creatingPurchaseInProgress: false,
      errorMessage: 'ERROR_CREATING_PURCHASE',
    })
  ),
  on(
    actions.setPaymentStarted,
    (state): PurchaseState => ({
      ...state,
      loadingPurchase: true,
      errorMessage: null,
    })
  ),
  on(
    actions.setPaymentStartedSuccess,
    (state, { updatedPurchase }): PurchaseState => ({
      ...state,
      loadingPurchase: false,
      myPurchase: { ...state.myPurchase, status: updatedPurchase.status, updatedAt: updatedPurchase.updatedAt },
      errorMessage: null,
    })
  ),
  on(
    actions.setPaymentStartedError,
    (state, { errorMessage }): PurchaseState => ({
      ...state,
      loadingPurchase: false,
      errorMessage,
    })
  ),
  on(
    actions.verifyPayment,
    (state): PurchaseState => ({
      ...state,
      loadingPurchase: true,
      errorMessage: null,
    })
  ),
  on(
    actions.verifyPaymentSuccess,
    (state, { updatedPurchase }): PurchaseState => ({
      ...state,
      loadingPurchase: false,
      myPurchase: { ...state.myPurchase, ...updatedPurchase },
      errorMessage: null,
    })
  ),
  on(
    actions.verifyPaymentError,
    (state, { errorMessage }): PurchaseState => ({
      ...state,
      loadingPurchase: false,
      errorMessage,
    })
  ),
  on(
    actions.getMyPurchaseList,
    actions.getPurchaseListOfUser,
    (state): PurchaseState => ({
      ...state,
      loadingPurchaseList: true,
      errorMessage: null,
    })
  ),
  on(
    actions.getMyPurchaseListSuccess,
    actions.getPurchaseListOfUserSuccess,
    (state, { purchaseList }): PurchaseState => ({
      ...state,
      loadingPurchaseList: false,
      purchaseList: structuredClone(purchaseList),
      errorMessage: null,
    })
  ),
  on(
    actions.getMyPurchaseListError,
    actions.getPurchaseListOfUserError,
    (state): PurchaseState => ({
      ...state,
      loadingPurchase: false,
      purchaseList: [],
      errorMessage: 'CANNOT_FETCH_PURCHASE_LIST',
    })
  )
);

export function purchaseReducer(state: PurchaseState | undefined, action: Action): PurchaseState {
  return reducer(state, action);
}
